module.exports = __webpack_public_path__ + "static/media/PIVX.cc86b8e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currency-icons/PIVX.svg
// module id = 608
// module chunks = 0